import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { faqs } from '@/mocks/home';

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于入口与地址的疑问"
          desc="这里汇总了用户在查找入口时最常遇到的几个问题，点击条目即可展开查看完整说明。"
          align="center"
        />

        <div className="mt-10 md:mt-12 flex flex-col gap-3">
          {faqs.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={f.q}
                className={`rounded-lg border overflow-hidden transition-colors ${
                  isOpen ? 'bg-background-50 border-primary-300' : 'bg-background-50 border-background-200/70'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-4 md:py-5 cursor-pointer"
                >
                  <span className="flex items-start gap-3">
                    <span className="font-heading text-sm font-bold text-primary-600 mt-0.5">
                      {String(idx + 1).padStart(2, '0')}
                    </span>
                    <span className="text-sm md:text-base font-medium text-foreground-950 leading-relaxed">{f.q}</span>
                  </span>
                  <span className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 transition-colors ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'}`}>
                    <i className={isOpen ? 'ri-subtract-line text-base' : 'ri-add-line text-base'}></i>
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-6 pb-5 md:pb-6 pl-5 md:pl-16 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}